import fetch from "@/fetch";

//用户积分统计
export const getPoint = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/userpoint/getuserpointtotal",
    data: params,
    actionTypeCode: "45",
    actionTypeDesc: "用户积分统计获取",
    loading: true,
  });
};

//用户积分明细
export const getPointDetails = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/userpoint/getpointdetailslist",
    data: params,
    actionTypeCode: "46",
    actionTypeDesc: "用户积分明细获取",
    loading: true,
  });
};

//用户积分规则列表
export const getPointRule = () => {
  return fetch({
    method: "post",
    url: "/console/h5/userpoint/getpointrulelist",
    actionTypeCode: "47",
    actionTypeDesc: "积分规则列表获取",
    loading: true,
  });
};

//用户积分报表
export const getPointDetailsTotal = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/userpoint/getpointdetailstotal",
    data: params,
    actionTypeCode: "48",
    actionTypeDesc: "用户积分报表获取",
    loading: true,
  });
};

// 用户积分和签到状态获取
export const userPointSignGet = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/userpoint/getuserpoint",
    data: params,
    actionTypeCode: "49",
    actionTypeDesc: "用户积分和签到状态获取",
    loading: true,
  });
};

// 用户签到
export const userSignin = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/userpoint/usersignin",
    data: params,
    actionTypeCode: "50",
    actionTypeDesc: "用户签到",
    loading: true,
  });
};

//获取积分说明富文本
export const getDetails = () => {
  return fetch({
    method: "post",
    url: "/console/pointexplain/getdetails",
    actionTypeCode: "54",
    actionTypeDesc: "积分说明富文本",
    loading: true,
  });
};
